<ng-container *appTranslate="let t">
  @let current = widget();
  <p-card styleClass="h-full" data-testid="dashboard-branding-widget">
    <div class="flex max-mobile:flex-col items-stretch gap-6">
      <div class="w-1 shrink-0 rounded-full bg-teal-500 max-mobile:w-full max-mobile:h-1"></div>

      @if (current.logoUrl) {
        <div
          class="shrink-0 flex items-center max-mobile:justify-center"
          [class.max-w-48]="!isLargeLogo()"
          [class.max-w-72]="isLargeLogo()"
        >
          <img
            class="object-contain max-w-full"
            [class.max-h-14]="!isLargeLogo()"
            [class.max-h-28]="isLargeLogo()"
            [src]="current.logoUrl"
            [alt]="current.organizationName"
            data-testid="dashboard-branding-widget-logo"
          />
        </div>
      }

      @if (current.textHtml) {
        <!-- no safe pipe: the text is written by other organizations, so Angular's sanitizing must stay active -->
        <div
          class="flex-auto min-w-0 ql-editor-readonly text-body-text-regular"
          [innerHTML]="current.textHtml"
          data-testid="dashboard-branding-widget-text"
        ></div>
      } @else {
        <div class="flex-auto"></div>
      }

      @if (current.dashboardWidgetLinks.length > 0) {
        <div class="col shrink-0 justify-center gap-2 max-mobile:w-full">
          @for (link of current.dashboardWidgetLinks; track $index) {
            <a
              class="row justify-between gap-4 text-text-body max-mobile:w-full"
              [href]="link.linkUrl"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="dashboard-branding-widget-link"
            >
              <span class="text-text-caption">{{ link.linkText || t("dashboardWidget.linkFallback") }}</span>
              <i class="size-6 shrink-0 icon-[mi--exit-log-out-2]" aria-hidden="true"></i>
            </a>
          }
        </div>
      }
    </div>
  </p-card>
</ng-container>
